function PayApiClientBase(baseURL, username, password, franchiseID) {
    var _self = this;

    if(baseURL.charAt(baseURL.length - 1) == '/')
        baseURL = baseURL.slice(0, -1);

    this.baseURL = baseURL;
    this.username = username;
    this.password = password;
    this.franchiseID = franchiseID;
    this.providerName = 'Pay';
    this.errorMessages = {
        unauthorizedMessage: 'Authorization has been denied for this request.',
        invalidRefreshToken: 'invalid_grant',
        failedToFetch: 'Failed to fetch'
    };

    var errorEventHandler = new PayApiClientEventHandler(this);
    this.OnErrorOccured = function (event) {
        if (typeof event === 'function')
            errorEventHandler.attach(event);
        else {
            var promise = _self.init();
            errorEventHandler.invoke(event);
            return promise;
        }
    };

    this.pay = {};
    this.pay.payment = {};
    this.pay.payment.create = {};
    this.pay.payment.get = {};

    /*
    Request data structure:
    {
        Amount: Decimal,
        FranchiseID: Int32,
        BranchID: Int32,
        ReferenceNo: String
    }
    */
    // [AllowAnonymous]
    this.pay.payment.create.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/pay/payment/create/v1', 'POST', data)
                .then(function (result) {
                    resolve(result);
                })
                .catch(error => {
                    errorEventHandler.invoke(error);
                    reject(error);
                });
        });
    };
    /*
    Request data structure:
    {
        FranchiseID: Int32,
        BranchID: Int32,
        ReferenceNo: String
    }
    */
    // [AllowAnonymous]
    this.pay.payment.get.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/pay/payment/get/v1', 'POST', data)
                .then(function (result) {
                    resolve(result);
                })
                .catch(error => {
                    errorEventHandler.invoke(error);
                    reject(error);
                });
        });
    };
    /*
    Request data structure:
    {
        Amount: Decimal,
        FranchiseID: Int32,
        BranchID: Int32,
        ReferenceNo: String
    }
    */
    // [AllowAnonymous]
    this.pay.payment.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/pay/payment/v1', 'POST', data)
                .then(function (result) {
                    resolve(result);
                })
                .catch(error => {
                    errorEventHandler.invoke(error);
                    reject(error);
                });
        });
    };
    this.authenticate = function (username, password) {
        var promise = new Promise((resolve, reject) => {

            var url = _self.baseURL + '/' + 'Token';
            var fetchBody = 'grant_type=password';
            fetchBody += '&username=' + encodeURIComponent(username);
            fetchBody += '&password=' + encodeURIComponent(password);
            fetchBody += '&providerName=' + encodeURIComponent(_self.providerName);
            fetchBody += '&providerArg1=' + encodeURIComponent(this.franchiseID);
            var fetchInitParams = {
                method: 'POST',
                body: fetchBody,
                headers: {
                    'content-type': 'application/x-www-form-urlencoded'
                }
            };

            var result = fetch(url, fetchInitParams);

            result
                .then((res) => res.text())
                .then((text) => text.length ? JSON.parse(text) : null)
                .then(function (data) {
                    if(data != null && data['access_token']){
                        localStorage.setItem('PayUserToken', data['access_token']);
                        localStorage.setItem('PayUserRefreshToken', data['refresh_token']);
                        resolve(data);
                    }
                    else {
                        reject(); // TODO: Create new error object to pass to reject.
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    reject(error);
                });

            });

        return promise;
    };
    this.refreshToken = function (refreshToken) {
        var promise = new Promise((resolve, reject) => {

            var url = _self.baseURL + '/' + 'Token';
            var fetchBody = 'grant_type=refresh_token';
            fetchBody += '&refresh_token=' + encodeURIComponent(refreshToken);

            var fetchInitParams = {
                method: 'POST',
                body: fetchBody,
                headers: {
                    'content-type': 'application/x-www-form-urlencoded'
                }
            };

            var result = fetch(url, fetchInitParams);

            result
                .then((res) => res.text())
                .then((text) => text.length ? JSON.parse(text) : null)
                .then(function (data) {
                    if(data != null && data['access_token']){
                        localStorage.setItem('PayUserToken', data['access_token']);
                        localStorage.setItem('PayUserRefreshToken', data['refresh_token']);
                        resolve(data);
                    }
                    else {
                        var error = new Error(data.error);
                        reject(error);
                    }
                })
                .catch(function (error) {
                    reject(error);
                });

            });

        return promise;
    };
    function fetchData(callURL, method, data, token) {
        var promise = new Promise((resolve, reject) => {

            var url = _self.baseURL + '/' + callURL;
            var fetchInitParams = {
                headers:{
                    'content-type':'application/json'
                }
            };
            
            if (data) {
                fetchInitParams.method = method;
                fetchInitParams.body= JSON.stringify(data);
            }

            if (token) {
                fetchInitParams.headers['Authorization'] = 'Bearer ' + token;
            }


            var result = fetch(url, fetchInitParams);

            result
                .then((res) => res.text())
                .then((text) => text.length ? JSON.parse(text) : null)
                .then(function (data) {
                    resolve(data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });

        return promise;
    }
}
function PayApiClientEventHandler(owner) {
    var sender = owner;
    var eventHandlers = [];

    this.attach = function (eventHandler) {
        eventHandlers.push(eventHandler);
    };
    this.invoke = function (event) {
        for (var i = 0; i < eventHandlers.length; i++) {
            if (eventHandlers[i]) {
                eventHandlers[i](sender, event);
            }
        }
    };
    this.clear = function () {
        eventHandlers = [];
    };
}
export { PayApiClientBase, PayApiClientEventHandler };